/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSpy = createReactComponent("spy", "IconSpy", [
  ["path", { d: "M3 11h18", key: "svg-0" }],
  ["path", { d: "M5 11v-4a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v4", key: "svg-1" }],
  ["path", { d: "M7 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-2" }],
  ["path", { d: "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-3" }],
  ["path", { d: "M10 17h4", key: "svg-4" }]
]);

export { IconSpy as default };
//# sourceMappingURL=IconSpy.js.map
